import { TileOrPhoneSupportActions } from "components/dynamic-content/util/dynamicContent"
import Breadcrumb from "components/views/atoms/Breadcrumb"
import { ITalkToCarrotLanguage, ITile } from "contentful-types"
import React from "react"
import { getLanguageName, getPathForLanguage, getPathForTile, getTileTitle } from "../utils/mappingUtils"

type PageBreadcrumbProps = {
  tile?: ITile
  language?: ITalkToCarrotLanguage
  baseUrl: string
  actions: TileOrPhoneSupportActions
  isActive?: boolean
}

const PageBreadcrumb = ({ tile, language, baseUrl, actions, isActive = false }: PageBreadcrumbProps) => {
  return tile ? (
    <Breadcrumb
      title={getTileTitle(tile) || "unknown"}
      isActive={isActive}
      onClick={() => actions.gotoPageAction(getPathForTile({ tile, baseUrl }))}
    />
  ) : (
    <Breadcrumb
      title={getLanguageName(language) || "unknown"}
      isActive={isActive}
      onClick={() => actions.gotoPageAction(getPathForLanguage({ language, baseUrl }))}
    />
  )
}

export default PageBreadcrumb
